import { BackgroundThemeRevision } from 'referral-types';
import { Waves1, Waves2, Waves3, Waves4, Waves5, Waves6, Waves7, HexProps } from './constants';

import './_styles.scss';

export enum HippieWavesSubThemeIds {
  waves1 = 'hippie-waves-1',
  waves2 = 'hippie-waves-2',
  waves3 = 'hippie-waves-3',
  waves4 = 'hippie-waves-4',
  waves5 = 'hippie-waves-5',
  waves6 = 'hippie-waves-6',
  waves7 = 'hippie-waves-7',
}

export const HippieWavesSubThemeOptions = [
  { value: HippieWavesSubThemeIds.waves1, label: 'Hippie Waves 1' },
  { value: HippieWavesSubThemeIds.waves2, label: 'Hippie Waves 2' },
  { value: HippieWavesSubThemeIds.waves3, label: 'Hippie Waves 3' },
  { value: HippieWavesSubThemeIds.waves4, label: 'Hippie Waves 4' },
  { value: HippieWavesSubThemeIds.waves5, label: 'Hippie Waves 5' },
  { value: HippieWavesSubThemeIds.waves6, label: 'Hippie Waves 6' },
  { value: HippieWavesSubThemeIds.waves7, label: 'Hippie Waves 7' },
];

export const HippieWavesBackground = (props: { themeRevision?: Partial<BackgroundThemeRevision> }) => {
  const { themeRevision } = props;
  let hexColors: HexProps;

  switch (themeRevision?.subTheme) {
    case HippieWavesSubThemeIds.waves1:
      hexColors = Waves1;
      break;
    case HippieWavesSubThemeIds.waves2:
      hexColors = Waves2;
      break;
    case HippieWavesSubThemeIds.waves3:
      hexColors = Waves3;
      break;
    case HippieWavesSubThemeIds.waves4:
      hexColors = Waves4;
      break;
    case HippieWavesSubThemeIds.waves5:
      hexColors = Waves5;
      break;
    case HippieWavesSubThemeIds.waves6:
      hexColors = Waves6;
      break;
    case HippieWavesSubThemeIds.waves7:
    default:
      hexColors = Waves7;
      break;
  }

  return (
    <svg
      style={{ backgroundColor: hexColors.background }}
      className="bg-hippie-waves relative -z-10 h-full w-full"
      preserveAspectRatio="xMidYMid slice"
      viewBox="10 10 80 80"
    >
      <path
        fill={hexColors.outTop}
        className="out-top"
        d="M37-5C25.1-14.7,5.7-19.1-9.2-10-28.5,1.8-32.7,31.1-19.8,49c15.5,21.5,52.6,22,67.2,2.3C59.4,35,53.7,8.5,37-5Z"
      />
      <path
        fill={hexColors.inTop}
        className="in-top"
        d="M20.6,4.1C11.6,1.5-1.9,2.5-8,11.2-16.3,23.1-8.2,45.6,7.4,50S42.1,38.9,41,24.5C40.2,14.1,29.4,6.6,20.6,4.1Z"
      />
      <path
        fill={hexColors.outBottom}
        className="out-bottom"
        d="M105.9,48.6c-12.4-8.2-29.3-4.8-39.4.8-23.4,12.8-37.7,51.9-19.1,74.1s63.9,15.3,76-5.6c7.6-13.3,1.8-31.1-2.3-43.8C117.6,63.3,114.7,54.3,105.9,48.6Z"
      />
      <path
        fill={hexColors.inBottom}
        className="in-bottom"
        d="M102,67.1c-9.6-6.1-22-3.1-29.5,2-15.4,10.7-19.6,37.5-7.6,47.8s35.9,3.9,44.5-12.5C115.5,92.6,113.9,74.6,102,67.1Z"
      />
    </svg>
  );
};
